// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1xVhd","info":"Note_info__EVx52","note":"Note_note__2PkIZ","actions":"Note_actions__2ps7P"};